@if (single) {
    <div class='notification'>
        <strong>השירות ניתן בכל הארץ</strong>
    </div>
} @else if (areaSearchState.searchState.onlyNational()) {
    <div class='notification'>
        <strong>כל השירותים הם כלל ארציים:&nbsp;</strong>טלפוניים, אינטרנטיים וכדו׳
    </div>
}
